'use strict';

const mobileNav = document.querySelector('.canton-active');

mobileNav.addEventListener('mousedown', function() {
    this.parentNode.classList.toggle('nav-open');
});